export default __webpack_public_path__ + "static/media/glad-you-were-born.603130ef.webp";